<template>
  <div>
    <Modal v-model="modal" :title="!cloudUserWarningForm.id ? this.$t('alarms.cloudUser.addCloudUserAlarm'):this.$t('alarms.cloudUser.editCloudUserAlarm')" @on-cancel="cancel" @on-ok="ok" :loading="loading" :mask-closable="false" :styles="{top:'65px'}" width="800px" :footer-hide="true" :closable="false">
      <Form ref="cloudUserWarningForm" :model="cloudUserWarningForm" :label-width="110" :rules="ruleValidate">
        <!-- 下一步 -->
        <div v-show="isNext">
          <!-- 微信警告 -->
          <wechat-warning v-if="wechatWarningVisible" ref="wechatWarning"></wechat-warning>
          <!-- 规则名称 -->
          <FormItem :label="$t('alarms.common.ruleName')" prop="ruleName" v-if="isEditRuleName">
            <Row>
              <Col span="11">
                <Input type="text" v-model="cloudUserWarningForm.ruleName" placeholder="Enter something..."
                       style="width:300px;" :disabled="isEdit"></Input>
              </Col>
            </Row>
          </FormItem>

          <!-- 规则名称 -->
          <FormItem :label="$t('alarms.common.ruleName')" v-if="showRuleName">
            <Row>
              <Col span="24">
                <div>{{this.cloudUserWarningForm.ruleName}}</div>
              </Col>
            </Row>
          </FormItem>

          <!-- 规则描述 -->
          <FormItem :label="$t('alarms.common.ruleDescription')">
            <Row :gutter="4">
              <!-- 监控指标 -->
              <Col span="4">
                <FormItem prop="monitorIndex">
                  <Select v-model="cloudUserWarningForm.monitorIndex"
                          @on-change="changeMonitorIndex(cloudUserWarningForm.monitorIndex)" :placeholder="$t('alarms.common.pleaseSelect')">
                    <Option :value="item.id" v-for="item in monitorIndexList" :key="item.id">{{item.name}}</Option>
                  </Select>
                </FormItem>
              </Col>
              <!-- 周期 -->
              <Col span="3">
                <FormItem prop="cycle">
                  <Select v-model="cloudUserWarningForm.cycle" :placeholder="$t('alarms.common.cycle')"
                          @on-change="changeCycle(cloudUserWarningForm.cycle)">
                    <Option :value="item.id" v-for="(item,index) in cycleList" v-bind:key="index">{{item.name}}</Option>
                  </Select>
                </FormItem>
              </Col>
              <!-- 连续周期 -->
              <Col span="4">
                <FormItem prop="continousCycle">
                  <Select v-model="cloudUserWarningForm.continousCycle" :placeholder="$t('alarms.common.continuousCycle')"
                          @on-change="changeContinousCycle(cloudUserWarningForm.continousCycle)">
                    <Option :value="item.id" v-for="(item,index) in continousCycleList" v-bind:key="index">
                      {{item.name}}
                    </Option>
                  </Select>
                </FormItem>
              </Col>
              <!-- 统计数值 -->
              <Col span="4">
                <FormItem prop="statisticsValue">
                  <Select v-model="cloudUserWarningForm.statisticsValue" :placeholder="$t('alarms.common.statisticsValue')"
                          @on-change="changeStatisticsValue(cloudUserWarningForm.statisticsValue)">
                    <Option :value="item.id" v-for="(item,index) in statisticsValueList" v-bind:key="index">
                      {{item.name}}
                    </Option>
                  </Select>
                </FormItem>
              </Col>


              <!-- 如果监控指标为IAM用户登录时 不显示符号、阈值和单位 -->
              <div v-if="this.isShowField!=1">
                <!-- 关系符号 -->
                <Col span="3">
                  <FormItem prop="relationshipSign">
                    <Select v-model="cloudUserWarningForm.relationshipSign" @on-change="changeRelationshipSign(cloudUserWarningForm.relationshipSign)" :placeholder="$t('alarms.common.symbol')">
                      <Option :value="item.id" v-for="(item,index) in relationshipSignList" v-bind:key="index">
                        {{item.name}}
                      </Option>
                    </Select>
                  </FormItem>
                </Col>
                <!-- 阈值 -->
                <Col span="3">
                  <FormItem prop="thresholdValue">
                    <Input v-model="cloudUserWarningForm.thresholdValue" :placeholder="$t('alarms.common.threshold')"
                           type="number" disabled></Input>
                  </FormItem>
                </Col>
              </div>
              <div v-else-if="this.isShowField==2">
                <!-- 关系符号 -->
                <Col span="3">
                  <FormItem prop="relationshipSign">
                    <Select v-model="cloudUserWarningForm.relationshipSign"
                            @on-change="changeRelationshipSign(cloudUserWarningForm.relationshipSign)"
                            :placeholder="$t('alarms.common.symbol')">
                      <Option :value="item.id" v-for="(item,index) in relationshipSignList" v-bind:key="index">
                        {{item.name}}
                      </Option>
                    </Select>
                  </FormItem>
                </Col>
                <!-- 阈值 -->
                <Col span="3">
                  <FormItem prop="thresholdValue">
                    <Input v-model="cloudUserWarningForm.thresholdValue" :placeholder="$t('alarms.common.threshold')"
                           type="number"></Input>
                  </FormItem>
                </Col>
                <!-- 单位 -->
                <Col span="2">
                  <FormItem prop="unit">
                    <Input v-model="cloudUserWarningForm.unit" disabled :placeholder="$t('alarms.common.unit')"></Input>
                  </FormItem>
                </Col>
              </div>
            </Row>
          </FormItem>

          <!-- 联系方式 -->
          <FormItem :label="$t('alarms.common.contactType')" prop="contactType">
              <RadioGroup v-model="cloudUserWarningForm.contactType" @on-change="changeContactType(cloudUserWarningForm.contactType)">
                  <Radio v-for="item in contactTypeList" :label="item.type" :key="item.value">{{item.label}}</Radio>
              </RadioGroup>
          </FormItem>

          <!-- 通知对象 -->
          <FormItem :label="$t('alarms.common.notificationObject')" v-if="cloudUserWarningForm.contactType==0">
            <Select v-model="cloudUserWarningForm.notificationObject" multiple style="width:300px;" @on-change="changeNotificationObject" :placeholder="$t('alarms.common.pleaseSelect')">
              <Option v-for="item in notificationObjectList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>

          <!-- 联系人组 -->
          <FormItem :label="$t('alarms.common.contactGroup')" v-if="cloudUserWarningForm.contactType==1">
            <Select v-model="cloudUserWarningForm.contactGroupIds" multiple style="width:300px;" @on-change="changeContactGroupId(cloudUserWarningForm.contactGroupIds)" :placeholder="$t('alarms.common.pleaseSelect')">
              <Option v-for="item in contactGroupIdList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>

          <!-- 报警方式 -->
          <FormItem :label="$t('alarms.common.noticeType')" prop="noticeType">
            <Select v-model="cloudUserWarningForm.noticeType" multiple style="width:300px;" @on-change="selectnoticeType(cloudUserWarningForm.noticeType)" :placeholder="$t('alarms.common.pleaseSelect')">
              <Option v-for="item in alarmWayList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>

          <!-- 企业微信机器人URL -->
          <FormItem :label="$t('alarms.common.enterpriseWeChatRobotURL')" prop="enterpriseWechatRobotIds" v-if="cloudUserWarningForm.noticeType.filter(function (e) { return e == 3; }).length != 0">
            <Select v-model="cloudUserWarningForm.enterpriseWechatRobotIds" multiple style="width:300px;" :placeholder="$t('alarms.common.pleaseSelect')">
              <Option v-for="item in enterpriseWechatRobotIdsList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>

          <!-- 延迟告警 -->
          <FormItem :label="$t('alarms.common.alarmDelay')" prop="alarmDelay">
            <Select v-model="cloudUserWarningForm.alarmDelay" style="width:300px;" :placeholder="$t('alarms.common.pleaseSelect')">
              <Option v-for="item in alarmDelayList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>

          <!-- 邮箱模板 -->
          <div v-show="isShowEmail">
            <FormItem :label="$t('alarms.common.emailModal')" prop="emailModal">
              <Input v-model="cloudUserWarningForm.emailModal" type="textarea"
                     :autosize="{minRows: 2,maxRows: 5}" style="width:665px;" disabled></Input>
            </FormItem>
          </div>

          <!-- 企业微信模板 -->
          <div v-show="isShowWeChat">
            <FormItem :label="$t('alarms.common.wechatModal')" prop="wechatModal">
              <Input v-model="cloudUserWarningForm.wechatModal" type="textarea"
                     :autosize="{minRows: 2,maxRows: 5}" style="width:665px;" disabled></Input>
            </FormItem>
          </div>
          <div style="height: 42px;">
            <Button type="primary" size="large" style="float: right;" @click="ok('cloudUserWarningForm')" :loading="addloading" :disabled="isAddOrEdit">
              {{!cloudUserWarningForm.id ? this.$t('common.addAlarm'):this.$t('common.editAlarm')}}
            </Button>
            <Button size="large" style="float: right;margin-right: 10px;"
                    @click="cancel('cloudUserWarningForm')">{{ $t('alarms.common.cancel') }}
            </Button>
            <Button size="large" @click="previousPage" style="float: right;margin-right: 10px;">{{ $t('alarms.common.lastStep') }}</Button>
          </div>
        </div>

        <!-- 上一步 -->
        <div v-show="isPrevious">
          <div>
            <Row :gutter="16">
              <Col span="8">
                <!-- 账户 -->
                <FormItem :label="$t('alarms.common.account')" prop="account" :label-width="70">
                  <Select v-model="cloudUserWarningForm.account"
                          @on-change="changeAccount(cloudUserWarningForm.account)" :transfer="true" :placeholder="$t('alarms.common.pleaseSelect')">
                    <Option :value="item.id" v-for="(item,index) in accountList" v-bind:key="index">{{item.name}}
                    </Option>
                  </Select>
                </FormItem>
              </Col>
              <Col span="10" style="z-index: 200">
                <!-- 存储区域 -->
                <FormItem :label="$t('alarms.common.region')" prop="backupRegion">
                  <Select @on-change="changebackupRegion(cloudUserWarningForm.backupRegion)"
                          v-model="cloudUserWarningForm.backupRegion" multiple :max-tag-count="1" :transfer="true" :placeholder="$t('alarms.common.pleaseSelect')">
                    <Checkbox v-model="singleBackupRegion" @on-change="selectBackupRegionAll" style="display: block;text-align:right;">{{ $t('alarms.common.all') }}</Checkbox>
                    <Option :value="item.name" v-for="item in backupRegionList" :key="item.id">{{item.name}}</Option>
                  </Select>
                </FormItem>
              </Col>
              <Button type="primary" style="float:right;" v-show="isShowSearch" @click="searchCloudUserDate">{{ $t('alarms.common.search') }}</Button>
            </Row>
          </div>

          <v-table :height="459" column-width-drag is-horizontal-resize
                   style="width:100%;height:459px;margin-bottom: 15px;" :columns="column" :table-data="tableCloudUserDate"
                   row-hover-color="#edf7ff" :is-loading="modal_loadings" title-bg-color="#f8f8f9"
                   :select-group-change="selectChange" :select-all="selectAll"></v-table>
          <div style="height: 42px;">
            <Button type="primary" size="large" @click="nextPage" style="float: right;" :disabled="isNextClick">{{ $t('alarms.common.nextStep') }}
            </Button>
            <Button size="large" style="margin-right: 10px;float: right;"
                    @click="cancel('cloudUserWarningForm')">{{ $t('alarms.common.cancel') }}
            </Button>
          </div>
        </div>
      </Form>
    </Modal>
  </div>
</template>
<script>
    import WechatWarning from '../common/WechatWarning.vue'
    import {setCookie, getCookie} from '../../../utils/cookieUtil.js'
    import TableCloudUser from '../cloud_user/TableCloudUser.vue'

    var tableCloudUser = TableCloudUser;
    var tableCloudUserWarningVue = {}
    export default {
        inject: ['reload'],
        components: {
            WechatWarning
        },
        data() {
            // 名字是否重复
            var validNameRepeatedCheck = (rule, value, callback) => {
                var self = this;
                self.$api.alertRule.nameRepeatedCheck({
                    "alertRuleName": this.cloudUserWarningForm.ruleName,
                    "monitorModule": this.monitorModule
                })
                .then(res => {
                    if (res.status == 200) {
                        callback();
                    }
                })
                .catch(err => {
                    if (err.status == 400) {
                        callback(new Error('规则名称不能重复!'));
                    }
                })
            };
            return {
                monitorModule:32,
                isAddOrEdit:true,
                wechatWarningVisible: false,
                contactTypeList: [{
                    label: this.$t('alarms.common.contactPerson'),
                    value: 'contact',
                    type: 0
                },
                    {
                        label: this.$t('alarms.common.contactGroup'),
                        value: 'contactGroup',
                        type: 1
                    }],
                isShowField: 2, //是否显示符号、阈值和单位
                addloading:false,
                singleBackupRegion:false,
                alarmDelayList:[],
                isEdit: false,
                isShowSearch: false,
                isEditRuleName: false,
                showRuleName: false,
                modal_loadings: false,
                isShowEmail: false,
                isShowWeChat: false,
                isNext: false,
                isPrevious: true,
                selection: [],
                accountList: [],
                notificationObjectList: [],
                alarmWayList: [],
                backupRegionList: [],
                loading: true,
                modal: false,
                modal_loading: false,
                exportDataList: '',
                noticeType: [],
                units: '',
                isNextClick: true, //禁止点击下一步
                unit: '',
                cloudUserWarningForm: {
                    account: '',
                    ruleName: '',
                    notificationObject: [],
                    noticeType: [],
                    emailModal: '',
                    wechatModal: '',
                    thresholdValue: '',
                    monitorIndex: '',
                    cycle: '',
                    continousCycle: '',
                    statisticsValue: '',
                    relationshipSign: '',
                    unit: '',
                    backupRegion: [],
                    alarmDelay:'',
                    contactType:0,
                    contactGroupIds:[],
                    userIdList:[],
                    enterpriseWechatRobotIds:[]
                },
                enterpriseWechatRobotIdsList:[],
                // 联系人组
                contactGroupIdList:[],
                // 监控指标
                monitorIndexList: [],
                // 周期
                cycleList: [],
                // 连续周期
                continousCycleList: [],
                // 统计数值
                statisticsValueList: [],
                // 关系符号
                relationshipSignList: [],
                ruleValidate: {
                    account: [
                        {required: true, message: '请选择账户名称', trigger: 'change', type: 'number'}
                    ],
                    alarmDelay: [
                        {required: true, message: '请选择延迟告警', trigger: 'change', type: 'number'}
                    ],
                    backupRegion: [
                        {required: true, type: 'array', message: '请选择存储区域', trigger: 'change'}
                    ],
                    ruleName: [
                        {required: true, message: '规则名称不能为空', trigger: 'blur'},
                        {type: 'string', message: '规则名称为2-20个字符首尾中间不能有空格', pattern: '^[^ ]{2,20}$', trigger: 'blur'},
                        {validator: validNameRepeatedCheck, trigger: 'blur'}
                    ],
                    notificationObject: [
                        {required: true, type: 'array', message: '请选择通知对象', trigger: 'change'}
                    ],
                    noticeType: [
                        {required: true, type: 'array', min: 1, message: '请选择报警方式', trigger: 'change'}
                    ],
                    monitorIndex: [
                        {required: true, message: '请选择监控指标', trigger: 'change', type: 'number'}
                    ],
                    cycle: [
                        {required: true, message: '请选择周期', trigger: 'change', type: 'number'}
                    ],
                    continousCycle: [
                        {required: true, message: '请选择连续周期', trigger: 'change', type: 'number'}
                    ],
                    statisticsValue: [
                        {required: true, message: '请选择统计数值', trigger: 'change', type: 'number'}
                    ],
                    relationshipSign: [
                        {required: true, message: '请选择关系符号', trigger: 'change', type: 'number'}
                    ],
                    thresholdValue: [
                        {required: true, message: '请输入阈值'}
                    ],
                    contactType: [
                        {required: true, message: '请选择联系方式', trigger: 'change', type: 'number'}
                    ],
                    contactGroupIds: [
                        {required: true, message: '请选择联系人组', trigger: 'change', type: 'array'}
                    ],
                    enterpriseWechatRobotIds: [
                      {required: true, type: 'array', message: '请选择企业微信机器人URL', trigger: 'change'}
                    ]
                },
                column: [
                    {
                        width: 60,
                        titleAlign: 'center',
                        columnAlign: 'center',
                        type: 'selection'
                    },
                    {
                        field: 'cloudUserName',
                        title: this.$t('alarms.cloudUser.cloudUserName'),
                        width: 80,
                        titleAlign: 'center',
                        columnAlign: 'center',
                        isResize: true
                    },
                    {
                        field: 'region',
                        title: this.$t('alarms.common.region'),
                        width: 80,
                        titleAlign: 'center',
                        columnAlign: 'center',
                        isResize: true
                    }
                ],
                tableCloudUserDate: [],
                newTableCloudUserDateList: [],
                cloudUserList: [],
                cloudUserSearchList:[]
            }
        },

        beforeCreate: function () {
            tableCloudUserWarningVue = this
        },
        methods: {
            //显示表格数据
            /****************************************************************/
            // 下一步
            nextPage: function () {
                this.isNext = true;
                this.isPrevious = false;
                // 查询监控指标
                tableCloudUserWarningVue.searchMonitorIndex();
                // 查询阈值
                tableCloudUserWarningVue.selectMonitorIndexDefault();
                // 查询联系人组
                tableCloudUserWarningVue.listContactGroups();
            },
            // 上一步
            previousPage: function () {
                this.isNext = false;
                this.isPrevious = true;
            },
            init: function (id) {
                this.cloudUserWarningForm.id = id || 0;
                // 根据用户名查询Account列表
                tableCloudUserWarningVue.getAccount();
                this.$nextTick(() => {
                    // 重置表单
                    this.$refs['cloudUserWarningForm'].resetFields();
                    // 编辑
                    if (this.cloudUserWarningForm.id) {
                        // 编辑显示不能输入的规则名称
                        this.showRuleName = true;
                        this.isEdit = true;
                        this.isShowSearch = false;
                        this.$api.alertRule.selectAlertRule("id", this.cloudUserWarningForm.id)
                            .then(res => {
                                //延时
                                this.cloudUserWarningForm.alarmDelay = res.data.delay;
                                // 账户
                                /******************************************************/
                                this.cloudUserWarningForm.account = res.data.accountId;
                                tableCloudUserWarningVue.$api.account.queryAccountRegions("accountId", this.cloudUserWarningForm.account)
                                .then(res => {
                                    this.backupRegionList = res.data;
                                });

                              tableCloudUserWarningVue.$api.contact.queryContactsByAccountIdAndMonitorModule({
                                  "monitorModule":this.monitorModule,
                                  "accountId":this.cloudUserWarningForm.account
                                })
                                .then(res => {
                                  this.notificationObjectList = res.data.contactList;
                                });

                                this.modal_loadings = true;

                                setTimeout(() => {
                                    // 存储区域
                                    this.cloudUserWarningForm.backupRegion = res.data.regions;

                                    // 列表
                                    /******************************************************/
                                    this.cloudUserList = res.data.resourceCloudUserDTOS;

                                    this.cloudUserSearchList=res.data.resourceCloudUserDTOS;
                                    // 根据AccountId查询列表
                                    tableCloudUserWarningVue.$api.resourceCloudUser.listCloudUserByAccount({
                                        "regions": this.cloudUserWarningForm.backupRegion,
                                        "accountId": this.cloudUserWarningForm.account
                                    })
                                    .then(res => {
                                        this.tableCloudUserDate = res.data;
                                        this.modal_loadings = false;
                                        for (var i = 0; i < this.tableCloudUserDate.length; i++) {
                                            for (var j = 0; j < this.cloudUserSearchList.length; j++) {
                                                if (this.tableCloudUserDate[i].cloudUserName == this.cloudUserSearchList[j].cloudUserName) {
                                                    this.tableCloudUserDate[i]._checked = true;
                                                }
                                            }
                                        }
                                        // 选了数据 可以点击下一步
                                        if (this.tableCloudUserDate.length == 0 || this.cloudUserSearchList.length == 0) {
                                            this.isNextClick = true;
                                        } else {
                                            this.isNextClick = false;
                                        }
                                    })
                                }, 1000)

                                this.newTableCloudUserDateList = res.data.resourceCloudUserDTOS;


                                // 规则名称
                                this.cloudUserWarningForm.ruleName = res.data.alertRuleName;

                                // 监控指标
                                /******************************************************/
                                this.cloudUserWarningForm.monitorIndex = res.data.monitorIndex;
                                // 如果监控指标为IAM用户登录时 不显示符号、阈值和单位
                                if (this.cloudUserWarningForm.monitorIndex == 57) {
                                    this.isShowField = 1;
                                } else {
                                    this.isShowField = 2;
                                }
                                // 周期
                                this.cloudUserWarningForm.cycle = res.data.cycle;
                                // 连续周期
                                this.cloudUserWarningForm.continousCycle = res.data.continousCycle;
                                // 统计数值
                                this.cloudUserWarningForm.statisticsValue = res.data.statisticsValue;
                                // 符号
                                this.cloudUserWarningForm.relationshipSign = res.data.relationshipSign;
                                // 阈值
                                this.cloudUserWarningForm.thresholdValue = res.data.thresholdValue;
                                // 单位
                                this.cloudUserWarningForm.unit = res.data.unit;
                                this.units = res.data.unitId;
                                // 企业微信机器人URL
                                this.cloudUserWarningForm.enterpriseWechatRobotIds=res.data.enterpriseWechatRobotIds;

                                // 联系方式
                                this.cloudUserWarningForm.contactType = res.data.contactType;
                                if(res.data.contactType==0){
                                    // 通知对象
                                    this.cloudUserWarningForm.notificationObject = res.data.contactIDs;
                                    for(var i=0;i<this.cloudUserWarningForm.notificationObject.length;i++){
                                        for(var j=0;j<this.notificationObjectList.length;j++){
                                            if(this.cloudUserWarningForm.notificationObject[i]==this.notificationObjectList[j].id){
                                                this.cloudUserWarningForm.userIdList.push(this.notificationObjectList[j].userId); //传值
                                            }
                                        }
                                    }
                                }else if(res.data.contactType==1){
                                    // 联系人组
                                    this.$api.contactGroup.listContactGroupsByAccountId("accountId", this.cloudUserWarningForm.account)
                                    .then(res => {
                                        this.contactGroupIdList = res.data;
                                    })
                                    setTimeout(() => {
                                        this.cloudUserWarningForm.contactGroupIds = res.data.contactGroupIds;
                                    }, 1000)
                                }

                                // 报警方式
                                this.cloudUserWarningForm.noticeType = res.data.noticeType;

                                for (var i = 0; i < this.cloudUserWarningForm.noticeType.length; i++){

                                  if (this.cloudUserWarningForm.noticeType[i] == '0') {
                                    this.isShowEmail = true;
                                    this.cloudUserWarningForm.emailModal = res.data.briefReportBodyMail;
                                    this.noticeType = this.cloudUserWarningForm.noticeType;
                                    tableCloudUserWarningVue.selectTemplate();
                                  }
                                  if (this.cloudUserWarningForm.noticeType[i] == '1') {
                                    // this.isShowWeChat = true;
                                    this.cloudUserWarningForm.wechatModal = res.data.briefReportBodyWechat;
                                    this.checkLeastOnePersonBoundWeChat();
                                    this.noticeType = this.cloudUserWarningForm.noticeType;
                                    tableCloudUserWarningVue.selectTemplate();
                                  }else if(this.cloudUserWarningForm.noticeType[i]!='1'){
                                      this.wechatWarningVisible=false;
                                      this.isAddOrEdit=false;
                                  }

                                }
                            })
                    } else {
                        this.tableCloudUserDate = [];
                        this.isEdit = false;
                        this.isShowSearch = true;
                        // 添加显示规则名称能输入
                        this.isEditRuleName = true;
                        this.showRuleName = false;
                    }
                })
                this.modal = true;
                this.isNext = false;
                this.isPrevious = true;
            },
            // 根据监控指标 显示不同单位
            /****************************************************************/
            // 清空周期、连续周期、统计数值、关系符号
            emptyDate: function () {
                this.cloudUserWarningForm.cycle = '';
                this.cloudUserWarningForm.continousCycle = '';
                this.cloudUserWarningForm.statisticsValue = '';
                this.cloudUserWarningForm.relationshipSign = '';
                this.cloudUserWarningForm.thresholdValue = '';
            },
            isNotEmpty: function (obj) {
                if (typeof obj === "undefined" || obj === null || obj === "") {
                    return false;
                } else {
                    return true;
                }
            },
            // 根据监控指标 显示不同单位
            changeMonitorIndex: function () {
                // 如果监控指标为IAM用户登录时 不显示符号、阈值和单位
                if (this.cloudUserWarningForm.monitorIndex == 57) {
                    this.isShowField = 1;
                } else {
                    this.isShowField = 2;
                }
                tableCloudUserWarningVue.selectMonitorIndexDefault();
                this.unit = this.cloudUserWarningForm.monitorIndex;
                for (var i = 0; i < this.monitorIndexList.length; i++) {
                    if (this.monitorIndexList[i].id == this.unit) {
                        this.cloudUserWarningForm.unit = this.monitorIndexList[i].unit;
                        this.units = this.monitorIndexList[i].id;
                    }
                }
                tableCloudUserWarningVue.selectTemplate();
                tableCloudUserWarningVue.emptyDate();
            },
            // 查询阈值
            /****************************************************************/
            selectMonitorIndexDefault: function () {
                if (this.cloudUserWarningForm.account == "" || this.cloudUserWarningForm.account == null) {
                    return;
                }
                tableCloudUserWarningVue.$api.alertRule.selectMonitorIndexDefault({
                    "monitorIndex": this.cloudUserWarningForm.monitorIndex,
                    "monitorModule": this.monitorModule,
                    "cycle": this.cloudUserWarningForm.cycle,
                    "continousCycle": this.cloudUserWarningForm.continousCycle,
                    "statisticsValue": this.cloudUserWarningForm.statisticsValue,
                    "relationshipSign": this.cloudUserWarningForm.relationshipSign,
                    "accountId": this.cloudUserWarningForm.account
                })
                .then(res => {
                    // 周期
                    this.cycleList = res.data.cycleMap;
                    // 连续周期
                    this.continousCycleList = res.data.continousCycleMap;
                    // 统计数值
                    this.statisticsValueList = res.data.statisticsValueMap;
                    // 关系符号
                    this.relationshipSignList = res.data.relationshipSignMap;
                    // 阈值
                    if (res.data.companyMonitoritemVariablesList.length == 1 && tableCloudUserWarningVue.isNotEmpty(this.cloudUserWarningForm.cycle) && tableCloudUserWarningVue.isNotEmpty(this.cloudUserWarningForm.continousCycle) && tableCloudUserWarningVue.isNotEmpty(this.cloudUserWarningForm.statisticsValue) && tableCloudUserWarningVue.isNotEmpty(this.cloudUserWarningForm.relationshipSign) && this.cloudUserWarningForm.id == 0) {
                        this.cloudUserWarningForm.thresholdValue = res.data.companyMonitoritemVariablesList[0].customerMonitorIndexDefaultValue;
                    }

                })
            },
            // 查询邮件模板
            /****************************************************************/
            selectTemplate: function () {
                tableCloudUserWarningVue.$api.briefReport.selectTemplate({
                    "monitorIndex": this.cloudUserWarningForm.monitorIndex,
                    "relationshipSign": this.cloudUserWarningForm.relationshipSign,
                    "monitorModule":this.monitorModule,
                    "noticeType": this.cloudUserWarningForm.noticeType
                })
                .then(res => {
                    this.cloudUserWarningForm.wechatModal = res.data.briefReportBodyWechat;
                    this.cloudUserWarningForm.emailModal = res.data.briefReportBodyMail;
                })
            },
            //报警方式为邮箱显示邮箱模板  为企业微信显示企业微信模板
            selectnoticeType: function () {
              this.isShowEmail = false;
              this.isShowWeChat = false;
              for(var i=0;i<this.cloudUserWarningForm.noticeType.length;i++) {
                if (this.cloudUserWarningForm.noticeType[i] == '0') {
                  this.isShowEmail = true;
                  this.noticeType = this.cloudUserWarningForm.noticeType;
                  tableCloudUserWarningVue.selectTemplate();
                }
                if (this.cloudUserWarningForm.noticeType[i] == '1') {
                  // this.isShowWeChat = true;
                  this.noticeType = this.cloudUserWarningForm.noticeType;
                  this.checkLeastOnePersonBoundWeChat();
                  tableCloudUserWarningVue.selectTemplate();
                }else if(this.cloudUserWarningForm.noticeType[i]!='1'){
                    this.wechatWarningVisible=false;
                    this.isAddOrEdit=false;
                }
              }
            },
            // 检查至少有一人绑定过微信
            checkLeastOnePersonBoundWeChat:function(){
              for(var i=0;i<this.cloudUserWarningForm.noticeType.length;i++){
                  if(this.cloudUserWarningForm.noticeType[i]==1){
                      var weChatDate={
                          "contactType":this.cloudUserWarningForm.contactType
                      };
                      // 联系方式为 -联系人-
                      if(this.cloudUserWarningForm.contactType==0){
                          weChatDate.userIds=this.cloudUserWarningForm.userIdList;
                      }
                      // 联系方式为 -联系人组-
                      else if(this.cloudUserWarningForm.contactType==1){
                          weChatDate.contactGroupIds = this.cloudUserWarningForm.contactGroupIds;
                      }
                      this.$api.userWeChat.checkLeastOnePersonBoundWeChat(weChatDate)
                      .then(res => {
                          if(res.data){
                            // 可以添加告警
                            this.wechatWarningVisible=false;
                            this.isAddOrEdit=false;
                          }else{
                            // 不可以添加微信告警
                            this.wechatWarningVisible=true;
                            this.isAddOrEdit=true;
                          }
                      })
                  }else if(this.cloudUserWarningForm.noticeType[i]!=1){
                      this.wechatWarningVisible=false;
                      this.isAddOrEdit=false;
                  }
              }
            },
            // 联系人组
            listContactGroups:function(){
                this.$api.contactGroup.listContactGroupsByAccountId("accountId", this.cloudUserWarningForm.account)
                .then(res => {
                    this.contactGroupIdList = res.data;
                })
            },
            // 切换联系人组
            changeContactGroupId:function(){
               this.checkLeastOnePersonBoundWeChat();
            },
            // 切换通知对象
            changeNotificationObject:function(val){
              this.cloudUserWarningForm.userIdList=[];
              this.cloudUserWarningForm.notificationObject=val;
              for(var i=0;i<this.cloudUserWarningForm.notificationObject.length;i++){
                for(var j=0;j<this.notificationObjectList.length;j++){
                  if(this.cloudUserWarningForm.notificationObject[i]==this.notificationObjectList[j].id){
                     this.cloudUserWarningForm.userIdList.push(this.notificationObjectList[j].userId); //传值
                  }
                }
              }
              this.checkLeastOnePersonBoundWeChat();
            },
            // 切换联系方式
            changeContactType:function(){
              this.checkLeastOnePersonBoundWeChat();
            },
            //点击查询 加载全部数据
            /***********************************************************************************/
            searchCloudUserDate: function () {
                if (this.cloudUserWarningForm.account == "" || this.cloudUserWarningForm.account == null || this.cloudUserWarningForm.backupRegion == "" || this.cloudUserWarningForm.backupRegion == null) {
                    return;
                }
                this.modal_loadings = true;
                // 根据AccountId查询云用户列表
                tableCloudUserWarningVue.$api.resourceCloudUser.listCloudUserByAccount({
                    "regions": this.cloudUserWarningForm.backupRegion,
                    "accountId": this.cloudUserWarningForm.account
                })
                .then(res => {
                    this.tableCloudUserDate = res.data;
                    this.modal_loadings = false;
                })
            },

            /**************************************  查询  **************************************/
            // 查询监控指标
            searchMonitorIndex: function () {
                tableCloudUserWarningVue.$api.alertRule.searchMonitorIndex({
                  "monitorModule":this.monitorModule,
                  "accountId":this.cloudUserWarningForm.account
                })
                .then(res => {
                    this.monitorIndexList = res.data;
                })
            },
            // 查询通知对象
            queryContacts: function () {
                tableCloudUserWarningVue.$api.contact.queryContactsByAccountIdAndMonitorModule({
                  "monitorModule":this.monitorModule,
                  "accountId":this.cloudUserWarningForm.account
                })
                .then(res => {
                    this.notificationObjectList = res.data.contactList;
                    this.cloudUserWarningForm.notificationObject = res.data.defaultContactIds;
                })
            },
            // 查询报警方式
            alarmWay: function () {
                tableCloudUserWarningVue.$api.alertRule.alarmWay("userName",getCookie(global.cookieName))
                .then(res => {
                  this.alarmWayList = res.data;
              })
            },
             // 查询报警延迟
            getAlarmDelay: function () {
                tableCloudUserWarningVue.$api.alertRule.alarmDelay("userName",getCookie(global.cookieName))
                .then(res => {
                  this.alarmDelayList = res.data;
              })
            },
            // 周期
            changeCycle: function () {
                // 查询阈值
                tableCloudUserWarningVue.selectMonitorIndexDefault();
            },
            // 连续周期
            changeContinousCycle: function () {
                // 查询阈值
                tableCloudUserWarningVue.selectMonitorIndexDefault();
            },
            // 统计数值
            changeStatisticsValue: function () {
                // 查询阈值
                tableCloudUserWarningVue.selectMonitorIndexDefault();
            },
            // 关系符号
            changeRelationshipSign: function () {
                // 查询阈值
                tableCloudUserWarningVue.selectMonitorIndexDefault();
                // 邮件模板
                tableCloudUserWarningVue.selectTemplate();
            },
            // 根据用户名查询Account列表
            getAccount: function () {
                // 清空表格
                this.tableCloudUserDate = [];
                tableCloudUserWarningVue.$api.account.selectAccountByCloudPlatform("type",0)
                .then(res => {
                    this.accountList = res.data;
                })
                // 查询方式
                tableCloudUserWarningVue.alarmWay();
                 // 查询报警延时
                tableCloudUserWarningVue.getAlarmDelay();
                // 监控模块查询关联的机器人列表
                tableCloudUserWarningVue.listEnterpriseWechatRobotsByMonitorModule();
            },
            // 监控模块查询关联的机器人列表
            listEnterpriseWechatRobotsByMonitorModule:function(){
                tableCloudUserWarningVue.$api.enterpriseWechatRobot.listEnterpriseWechatRobotsByMonitorModule({
                  "monitorModule":this.monitorModule
                })
                .then(res => {
                  this.enterpriseWechatRobotIdsList = res.data;
                })
            },
            // 选择账户
            changeAccount: function () {
                if (this.cloudUserWarningForm.account == "" || this.cloudUserWarningForm.account == null) {
                    return;
                }
                this.cloudUserWarningForm.backupRegion = '';
                // 清空表格
                this.tableCloudUserDate = [];
                this.cloudUserList = [];
                this.isShowSearch = true;
                this.isNextClick = true;
                tableCloudUserWarningVue.$api.account.queryAccountRegions("accountId", this.cloudUserWarningForm.account)
                .then(res => {
                    this.backupRegionList = res.data;
                });
                // 查询通知对象
               tableCloudUserWarningVue.queryContacts();
                // 查询联系人组
                tableCloudUserWarningVue.listContactGroups();
            },
            /***********存储区域**************************/
            selectBackupRegionAll(){
                this.cloudUserWarningForm.backupRegion = []
                if (this.singleBackupRegion) {
                    this.backupRegionList.map((item) => {
                        this.cloudUserWarningForm.backupRegion.push(item.name)
                    })
                } else {
                    this.cloudUserWarningForm.backupRegion = []
                }
            },
            // 切换存储区域
            changebackupRegion: function (val) {
                if (val.length === this.backupRegionList.length&&val.length!=0) {
                    this.singleBackupRegion = true
                } else {
                    this.singleBackupRegion = false
                }
                // 表格数据为空、显示查询按钮、存储区域为空
                this.tableCloudUserDate = [];
                this.cloudUserList = [];
                this.isShowSearch = true;
                this.isNextClick = true;
            },
            // 全选 单选
            /***********************************************************************************/
            // 单选
            selectChange(selection) {
                // 所有数据
                this.selection = selection;
                // 清空数组
                this.newTableCloudUserDateList = [];
                for (var i = 0; i < this.selection.length; i++) {
                    var TableCloudUserCopy = new Object();
                    TableCloudUserCopy.cloudUserName = this.selection[i].cloudUserName;
                    TableCloudUserCopy.accountId = this.selection[i].accountId;
                    TableCloudUserCopy.region = this.selection[i].region;
                    this.newTableCloudUserDateList.push(TableCloudUserCopy);
                }
                // 选了数据 可以点击下一步
                if (this.newTableCloudUserDateList.length == 0) {
                    this.isNextClick = true;
                } else {
                    this.isNextClick = false;
                }
            },
            // 全选
            selectAll: function (selection) {
                // 所有数据
                this.selection = selection;
                // 清空数组
                this.newTableCloudUserDateList = [];
                for (var i = 0; i < this.selection.length; i++) {
                    // 状态
                    var TableCloudUserCopy = new Object();
                    TableCloudUserCopy.cloudUserName = this.selection[i].cloudUserName;
                    TableCloudUserCopy.accountId = this.selection[i].accountId;
                    TableCloudUserCopy.region = this.selection[i].region;
                    this.newTableCloudUserDateList.push(TableCloudUserCopy);
                }
                if (this.selection.length == 0) {
                    this.isNextClick = true;
                } else {
                    this.isNextClick = false;
                }
            },
            // 创建添加或编辑报警
            /**********************************************************************************/
            ok: function (name) {
                this.$refs[name].validate(valid => {
                    if (valid) {
                        var alertList = {
                            "alertRuleName": this.cloudUserWarningForm.ruleName,
                            "monitorIndex": this.cloudUserWarningForm.monitorIndex,
                            "cycle": this.cloudUserWarningForm.cycle,
                            "continousCycle": this.cloudUserWarningForm.continousCycle,
                            "statisticsValue": this.cloudUserWarningForm.statisticsValue,
                            "relationshipSign": this.cloudUserWarningForm.relationshipSign,
                            "accountId": this.cloudUserWarningForm.account,
                            "monitorModule": this.monitorModule,
                            "noticeType": this.cloudUserWarningForm.noticeType,
                            "unit": this.units,
                            "delay":this.cloudUserWarningForm.alarmDelay,
                            "thresholdValue":this.cloudUserWarningForm.thresholdValue,
                            "contactType":this.cloudUserWarningForm.contactType,
                            "enterpriseWechatRobotIds":this.cloudUserWarningForm.enterpriseWechatRobotIds
                        };

                         // 如果联系方式是联系人 传通知对象
                        if(this.cloudUserWarningForm.contactType == 0){
                            alertList.contactIDs = this.cloudUserWarningForm.notificationObject;
                        }
                        // 如果联系方式是联系人组 传联系人组
                        else if(this.cloudUserWarningForm.contactType == 1){
                          alertList.contactGroupIds = this.cloudUserWarningForm.contactGroupIds;
                        }

                        if (this.cloudUserWarningForm.id > 0) {
                            alertList.id = this.cloudUserWarningForm.id;
                            alertList.resourceCloudUserDTOS = this.newTableCloudUserDateList;
                            // 编辑告警
                            this.addloading=true;
                            tableCloudUserWarningVue.$api.alertRule.updateAlertRule(alertList)
                                .then(res => {
                                    this.data = res.data;
                                    setTimeout(() => {
                                        this.reload();
                                        this.cloudUserWarningForm.notificationObject = [];
                                        this.$refs[name].resetFields();
                                        this.loading = false;
                                        this.$emit('on-ok', this.form);
                                        this.$nextTick(() => {
                                            this.loading = true;
                                        });
                                        this.$Message.success('编辑成功');
                                        // 禁止点击下一步
                                        this.isNextClick = true;
                                        this.isShowSearch = false;
                                        this.isShowEmail = false;
                                        this.isShowWeChat = false;
                                        this.addloading=false;
                                        this.modal = false;
                                        this.wechatWarningVisible=false;
                                        this.isAddOrEdit=true;
                                    }, 1000);
                                })
                        } else {
                            // 添加告警
                            this.addloading=true;
                            alertList.resourceCloudUserDTOS = this.newTableCloudUserDateList;
                            tableCloudUserWarningVue.$api.alertRule.createAlertRule(alertList)
                                .then(res => {
                                    this.data = res.data;
                                    setTimeout(() => {
                                        this.reload();
                                        tableCloudUser.methods.showAll();
                                        this.cloudUserWarningForm.notificationObject = [];
                                        this.$refs[name].resetFields();
                                        this.loading = false;
                                        this.$emit('on-ok', this.form);
                                        this.$nextTick(() => {
                                            this.loading = true;
                                        });
                                        this.$Message.success('添加成功');
                                        // 禁止点击下一步
                                        this.isNextClick = true;
                                        this.isShowEmail = false;
                                        this.isShowWeChat = false;
                                        this.addloading=false;
                                        this.modal = false;
                                        this.wechatWarningVisible=false;
                                        this.isAddOrEdit=true;
                                    }, 1000);
                                })
                        }
                    } else {
                        //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
                        this.loading = false;
                        setTimeout(() => {
                            this.loading = true
                        }, 0)
                        if (this.cloudUserWarningForm.id > 0) {
                            this.$Message.error('编辑失败');
                        } else {
                            this.$Message.error('添加失败');
                        }
                    }
                });
            },
            // 取消
            cancel: function (name) {
                this.wechatWarningVisible=false;
                this.isAddOrEdit=true;
                this.isShowSearch = false;
                this.isShowEmail = false;
                this.isShowWeChat = false;
                this.isNextClick = true;
                this.modal = false;
                this.$emit('on-cancel');
                this.cloudUserWarningForm.notificationObject = [];
                this.$nextTick(() => {
                    this.$refs[name].resetFields();
                });
                // 清空表格
                this.tableCloudUserDate = [];
            }
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/monitor/cloud_user/AddOrUpdateCloudUserWarning.vue